export default function(state, payload){
  state = {...state, ...payload}
  return {...state}
}